import { render, staticRenderFns } from "./ReaderToolbar.vue?vue&type=template&id=45cc3955&scoped=true&lang=pug&"
import script from "./ReaderToolbar.vue?vue&type=script&lang=js&"
export * from "./ReaderToolbar.vue?vue&type=script&lang=js&"
import style0 from "./ReaderToolbar.vue?vue&type=style&index=0&id=45cc3955&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/httpd/vhosts/tocin.com.tw/httpdocs/tocin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cc3955",
  null
  
)

export default component.exports